import type { Port } from "@/features/networks/types";
import { http } from "@/lib/http";

import type { TrafficMirror, TrafficMirrorCreateRequest } from "./types";

export async function listTrafficMirrors(): Promise<TrafficMirror[]> {
  const { data } = await http.get<TrafficMirror[]>("/network/traffic-mirrors");
  return data;
}

export async function getTrafficMirror(mirrorId: string): Promise<TrafficMirror> {
  const { data } = await http.get<TrafficMirror>(
    `/network/traffic-mirrors/${mirrorId}`,
  );
  return data;
}

export async function createTrafficMirror(
  payload: TrafficMirrorCreateRequest,
): Promise<TrafficMirror> {
  const { data } = await http.post<TrafficMirror>(
    "/network/traffic-mirrors",
    payload,
  );
  return data;
}

export async function deleteTrafficMirror(mirrorId: string): Promise<void> {
  await http.delete(`/network/traffic-mirrors/${mirrorId}`);
}

/** The ports of one server — what the monitor and each source are picked
 *  from. The port list is project-scoped, so a server the caller does not
 *  own simply has no ports here. */
export async function listServerPorts(serverId: string): Promise<Port[]> {
  const { data } = await http.get<Port[]>("/network/ports", {
    params: { device_id: serverId },
  });
  return data;
}
